<!-- <div class="w3-col m8 w3-container w3-margin-bottom info-container2 w3-center w3-hover-shadow w3-borderB"> -->
  <h5 style="color:#020202; background:#d3e1e7;" class="px-3"><b>1. State Public Information
      Officers</b></h5>

  <table class="w3-border" style="border-collapse:separate; margin-left:40px; width:90%;">
    <tr>
      <th>Sr.No.</th>
      <th>Name of Office</th>
      <th>Designation of SPIO</th>
      <th>Telephone No.</th>
    </tr>
    <tr>
      <td>1</td>
      <td>Head Office, MICADA, Haryana</td>
      <td>Officer on Special Duty </td>
      <td>0172 2567034 </td>
    </tr>
    <tr>
      <td>2</td>
      <td>MICAD Circle Rohtak</td>
      <td>Superintending Engineer (SPIO)</td>
      <td>01262-256006</td>
    </tr>
    <tr>
      <td>3</td>
      <td>MICAD Circle Karnal</td>
      <td>Superintending Engineer (SPIO)</td>
      <td>0184-2271054</td>
    </tr>
    <tr>
      <td>4</td>
      <td>MICAD Circle Hisar</td>
      <td>Superintending Engineer (SPIO)</td>
      <td>01662-227369</td>
    </tr>
    <tr>
      <td>5</td>
      <td>MICAD Division Rohtak</td>
      <td>Executive Engineer(SPIO)</td>
      <td>01262-254552</td>
    </tr>
    <tr>
      <td>6</td>
      <td>MICAD Division Jhajjar</td>
      <td>Executive Engineer(SPIO)</td>
      <td>01251-257076</td>
    </tr>
    <tr>
      <td>7</td>
      <td>MICAD Division Jind</td>
      <td>Executive Engineer(SPIO)</td>
      <td>01681-227072</td>
    </tr>
    <tr>
      <td>8</td>
      <td>MICAD Division Rewari</td>
      <td>Executive Engineer(SPIO)</td>
      <td>01274-260404</td>
    </tr>
    <tr>
      <td>9</td>
      <td>MICAD Division Kaithal</td>
      <td>Executive Engineer(SPIO)</td>
      <td>01746-224337</td>
    </tr>
    <tr>
      <td>10</td>
      <td>MICAD Division Karnal</td>
      <td>Executive Engineer(SPIO)</td>
      <td>0184-2271054</td>
    </tr>
    <tr>
      <td>11</td>
      <td>MICAD Division Kurukshetra</td>
      <td>Executive Engineer(SPIO)</td>
      <td>01744-238740</td>
    </tr>
    <tr>
      <td>12</td>
      <td>MICAD Division Panipat</td>
      <td>Executive Engineer(SPIO)</td>
      <td>0180-2650805</td>
    </tr>
    <tr>
      <td>13</td>
      <td>MICAD Division Hisar</td>
      <td>Executive Engineer(SPIO)</td>
      <td>01662-235425</td>
    </tr>
    <tr>
      <td>14</td>
      <td>MICAD Division Bhiwani</td>
      <td>Executive Engineer(SPIO)</td>
      <td>01664-244273</td>
    </tr>
    <tr>
      <td>15</td>
      <td>MICAD Division Fatehabad</td>
      <td>Executive Engineer(SPIO)</td>
      <td>01667-227125</td>
    </tr>
    <tr>
      <td>16</td>
      <td>MICAD Division Sirsa</td>
      <td>Executive Engineer(SPIO)</td>
      <td>01666-244129</td>
    </tr>

  </table><br>

  <h5 style="color:#020202; background:#d3e1e7;" class="px-3"><b>2. Assistant State Public
      Information Officers:</b></h5>

  <p style="font-size:11px; margin-left:15px; margin-right:10px; color:white; text-align: justify;"><b>1. Head
      office level Executive Engineer (Works)</b></p>
  <p style="font-size:11px; margin-left:15px; margin-right:10px; color:white; text-align: justify;"><b>2. MICAD
      Circle level concerned Superintendent/Circle Head Draftsman
    </b></p>
  <p style="font-size:11px; margin-left:15px; margin-right:10px; color:white; text-align: justify;"><b>3. MICAD
      Division level concerned Deputy Superintendent/Divisional
      Head Draftsman</b></p>

  <h5 style="color:#020202; background:#d3e1e7;" class="px-3"><b>3. Appellate Authority(1st) Chief
      Engineer, MICADA Haryana Panchkula</b></h5>

<!-- </div> -->